import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getNumMaxMessage,
    getReqMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const MAX_MINUTES = 10060;

export const checkActivity = (key, value, newErrors) => {
    if (!value || value < 1) {
        return {
            ...newErrors,
            [key]: { error: true, message: getReqMessage('A value') }
        };
    } else if (value > MAX_MINUTES) {
        return {
            ...newErrors,
            [key]: { error: true, message: getNumMaxMessage('Value', MAX_MINUTES) }
        };
    } else return newErrors;
};

export const validate = (newEntry, formType, initialEntry) => {
    let newErrors = {};

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    newErrors = checkActivity(
        'vigorousActivityMinutes',
        newEntry.vigorousActivityMinutes,
        newErrors
    );
    newErrors = checkActivity(
        'moderateActivityMinutes',
        newEntry.moderateActivityMinutes,
        newErrors
    );
    newErrors = checkActivity('walkingMinutes', newEntry.walkingMinutes, newErrors);

    if (Object.keys(newErrors).length < 1 && formType === 'edit') {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
